module.exports = __webpack_public_path__ + "files/bc7f88e7c1f64a6ac7e9d943562dc0d0.png";